/* @flow */
/* eslint-disable no-shadow, no-unused-vars */

import React from 'react';
import InternalLink from './InternalLink';

import type { QuickSearchLinkProps } from './types';

export default function QuickSearchLink({
  children,
  style,
  className,
  onClick,
  item,
}: QuickSearchLinkProps): React.Element {
  let to = `${item.type}`;
  let query = {id: item.id, did: item.id};
  return (<InternalLink
    to={`browse/${to}`}
    query={query} 
    style={style}
    className={className}
    onClick={onClick}
    withProjectPath
  >
    {children}
  </InternalLink>);
}
